export default "__VITE_ASSET__CD91dBlL__"